import axios from "axios";
import preloader from "./Preloader";

class ApplicationUserForm {
    static init($context = null) {
        var selector = "[data-application-type='application-user']";
        let $containers = $context ? $context.find(selector) : $(selector);

        $containers.each(function (index, element) {
            if ($(element).data('application_user_form_instance')) return;
            $(element).data('application_user_form_instance', new ApplicationUserForm(element))
        });
    }

    checkDataTimeoutId = null
    currentProgress = 0
    lastLoadedDataKey = null

    constructor(element) {
        this.version = '0.0.1'
        this.element = element;
        this.$element = $(element);
        this.$personalCode = this.$element.find('[name="code"]');
        this.$personalName = this.$element.find('[name="name"]');
        this.$personalSurname = this.$element.find('[name="surname"]');
        this.$email = this.$element.find('[name="email"]');
        this.$personalCode.on('change', this.onSourceValueChange.bind(this))
        this.$personalName.on('change', this.onSourceValueChange.bind(this))
        this.$personalSurname.on('change', this.onSourceValueChange.bind(this))
        //this.$email.closest('.form-group').addClass('d-none')

        this.onSourceValueChange();

    }
    basePath() {
        if ($('base').length) {
            return '';
        } else {
            return '/'
        }
    }

    onSourceValueChange() {

        clearTimeout(this.checkDataTimeoutId)
        if (!this.$personalCode.val() || !this.$personalName.val() || !this.$personalSurname.val()) return;
        this.checkDataTimeoutId = setTimeout(function () {
            this.validateFormData();
        }.bind(this), 500)
    }
    validateFormData(){
        preloader.show()

        axios.get(`${this.basePath()}api/applications/user_by_personal_code`, {
            params: {
                application: this.$element.data('application'),
                code: this.$personalCode.val(),
                name: this.$personalName.val(),
                surname: this.$personalSurname.val(),
            }
        }).then( response => {

            if(response.data){
                this.$element.find('[name="user"]').val(response.data.id).change();
                this.$personalName.val(response.data.name).attr('readonly', 'readonly');
                this.$personalSurname.val(response.data.surname).attr('readonly', 'readonly');

                if(response.data.email){
                    this.$element.find('[id="delegate_email_block"').removeClass('visible');

                    this.$element.find('label[for="name"] i.ph-asterisk, label[for="surname"] i.ph-asterisk').hide();
                }
            }
        }).catch( error => {
            this.$personalName.attr('readonly', null);
            this.$personalSurname.attr('readonly', null);
            this.$element.find('[name="user"]').val('').change();
            this.$element.find('[id="delegate_email_block"').addClass('visible');

            this.$element.find('label[for="name"] i.ph-asterisk, label[for="surname"] i.ph-asterisk').show();
            preloader.hide()
        }).finally(() => {
            preloader.hide()
        })

    }
}


if (typeof module === "object" && typeof module.exports === "object"){

    ApplicationUserForm.init()
    //node modules support
    module.exports = ApplicationUserForm;
}else{
    $(function(){
        ApplicationUserForm.init()
    });
}